<template>
<!-- 案例详情 -->
  <div>
    <div id="banner">
      <img class="img-responsive center-block" src="@/assets/img/example/img_1.png">
      <div class="banner-title">
        <h1 class="animated fadeInDown">智慧物流，连接世界</h1>
      </div>
    </div>
    <div id="example-content" class="container">
      <div class="Article">
        <p>{{exampleList[index].describe}}</p>
         <br>
         <img class="img-responsive center-block" :src="exampleList[index].img">
      </div>
      <div class="attribute hidden-xs">
        <h5>案例属性</h5>
        <p>应用产品：{{exampleList[index].title}}</p>
        <p>合作客户：{{exampleList[index].type}} {{exampleList[index].typeName}}</p>
        <p>业务地区： 中国</p>
        <p>业务类型： 物流</p>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name:"ExampleDetail",
   data(){
     return {
       index:"",
       exampleList:[
        {
          img: require("@/assets/img/example/example_1.png"),
          title:"快递揽件称重",
          type:"余杭百世",
          typeName:"F2",
          describe:"称重读码设备(F2)，在余杭百世操作现场，一天包裹量大概在5万件左右，13台称重读码设备，操作不到2小时即可操作完成，平均每小时扫描在2500以上。相比以前用PDA扫描，效率提升30%以上。",
          path:""
        },
        {
          img: require("@/assets/img/example/example_2.png"),
          title:"跨境电商体积测量",
          type:"杭州中外运",
          typeName:"FV1",
          describe:"称重读码测体积设备(FV1)，在杭州中外运操作现场，为每一个出口的包裹精准测量体积，对不同颜色的包裹，都能正常读取。误差在正负5mm，得到中外运领导高度认可。为跨境电商行业采集最精确的数据。",
          path:""
        },
        {
          img: require("@/assets/img/example/example_3.png"),
          title:"快递智能分拣",
          type:"上海奉贤中通",
          typeName:"P1",
          describe:"称重读码一分二设备(P1)，在上海奉贤中通操作现场，先用P1进行粗分。每一台设备分拣速率在2400件以上。大大提高操作效率。我司跟中通总部分拣接口完美对接，可以做一分二，一分四，一分六等设备。",
          path:""
        },
        {
          img: require("@/assets/img/example/example_4.png"),
          title:"电商快递揽件称重",
          type:"8090服饰",
          typeName:"F2",
          describe:"称重读码设备(F2)，在电商发货现场，直接在电商仓库发货可以把数据同时对接电商系统和快递系统，快递网点不需要二次扫描，大大节省劳动力，提高发货时效。目前我们设备可以对接所有电商系统和快递系统，在电商行业得到高度认可和广泛应用。",
          path:""
        },
      ]
     }
   },
   mounted(){
     this.index = this.$route.params.index
    

   }
 }

</script>

<style lang="less" scoped>
#banner{
  margin-bottom: 100px;
  position: relative;
  .banner-title{
    position: absolute;
    margin:auto;
    display: flex;
    flex-direction: column;
    top: 30%;
    left: 20%;
    color: #fff;
    h1{
      font-size: 64px;
    }
    p{
      font-size: 14px;
      
    }
  }
}
#example-content{
  margin-bottom: 100px;
  display: flex;
  justify-content: space-between;
  .Article{
    margin-right: 80px;
    p{
      text-indent: 2em;
    }
  }
  .attribute{
    height: 100%;
    padding-left: 20px;
    padding-bottom: 10px;
    border-left: 3px solid #0350C2;
    width: 300px;
    h5{
      font-size: 20px;
      font-weight: 600;
      color: #0350C2; 
    }
    p{
      font-size: 14px;
    }
  }
}
/* 媒体查询 手机端 */
@media screen and (max-width: 768px){
  #banner{
    margin-bottom: 50px;
    .banner-title{
      // top: 10%;
      text-align: center;
    }
    h1{
      font-size: 24px!important;
    }
  }
  #example-content{
    .Article{
      margin-right:   0px;
    }
  }
}
/* 媒体查询 平板 */
@media screen and (min-width: 768px) and (max-width: 996px){
  #banner{
    margin-bottom: 50px;
    .banner-title{
      // top: 10%;
      left: 0;
      text-align: center;
    }
    h1{
      font-size: 30px!important;
    }
  }
  #example-content{
    .Article{
      margin-right:   30px;
    }
  }
}
</style>